module.exports = "/images/defined_messages.png?ece849486ca124e09b59ec9d9bb8043d";